
export default {
  placesCarousel: {
    layer: 'Ebene',
    lat: 'Lat.',
    lon: 'Long.',
    notAvailable: 'Nicht verfügbar',
    placeDetails: 'Ort Details',
    next: 'Nächste Seite',
    prev: 'Vorherige Seite',
    directionsTo: 'Route hierher',
    distance: 'Entfernung',
    distanceFromLocationMarkedOnTheMap: 'Ungefähre Entfernung von markiertem Ort',
    selectPlace: 'Auswählen'
  }
}
